// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-display{display:flex;margin-bottom:20px;align-items:center}.contact-display--aligned-top{align-items:flex-start}.contact-display h3,.contact-display h4,.contact-display p{margin:0}.contact-display__icon{margin-right:15px}.contact-display__display-label{margin-bottom:3px}", ""]);
// Exports
module.exports = exports;
